export default "__VITE_ASSET__DkqbzSJ$__"